import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Review from './Components/Review'
import Actions from './Components/Actions'
import FullReviewModal from './Components/FullReviewModal'

class Reviews extends React.Component {
  constructor() {
    super()

    this.state = {
      fullReviewModalIsOpen: false,
      activeReview: null,
    }

    this.openFullReviewModal = this.openFullReviewModal.bind(this)
    this.closeFullReviewModal = this.closeFullReviewModal.bind(this)
  }

  openFullReviewModal(review) {
    this.setState({ fullReviewModalIsOpen: true, activeReview: review })
  }

  closeFullReviewModal() {
    this.setState({ fullReviewModalIsOpen: false, activeReview: null })
  }

  render() {
    return (
      <div className="row">
        {this.props.data.length > 0 ? (
          <Fragment>
            {this.props.data.map((review, index) => (
              <div className="col-12 col-md-6" key={index}>
                <Review review={review.attributes} openFullReviewModal={this.openFullReviewModal} />
              </div>
            ))}
            {this.state.activeReview
              && (
              <FullReviewModal
                modalIsOpen={this.state.fullReviewModalIsOpen}
                closeModal={this.closeFullReviewModal}
                review={this.state.activeReview}
              />
              )
            }
          </Fragment>
        ) : (
          <p className="col-12 no-reviews-message">No reviews yet</p>
        )}

        <div className="col-12 u-mt10 u-text-center">
          <Actions
            totalPages={this.props.totalPages}
            currentPage={this.props.page}
            onLoadMoreClick={this.props.onLoadMoreClick}
            openReviewModal={this.props.openReviewModal}
          />
        </div>
      </div>
    )
  }
}

Reviews.propTypes = {
  data: PropTypes.array,
  totalPages: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onLoadMoreClick: PropTypes.func.isRequired,
  openReviewModal: PropTypes.func.isRequired,
}

Reviews.defaultProps = {
  data: [],
}

export default Reviews
